import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Grid,
  Button,
  TextField,
  Box,
} from "@material-ui/core";
import * as Api from "../service";
import useStore from "../context";
import { useTranslation } from "localization/translation";


export default function Login2FA() {
  const [totpCode, setTotpCode] = useState("");
  const [loading, setLoading] = useState(false);

  const { setErrorMsg, setUser } = useStore();
  const translation = useTranslation();
  const history = useHistory();

  const tempToken = sessionStorage.getItem('tempToken');
  const rememberMe = localStorage.getItem('remember') === 'true';

  useEffect(() => {
    if (!tempToken) {
      history.replace('/');
    }
  }, [tempToken, history]);

  const handle2FAVerify = useCallback(async (e) => {
    e.preventDefault();

    if (totpCode.length !== 6) {
      return setErrorMsg(translation.err_code_length);
    }
    if (!tempToken) {
      return setErrorMsg(translation.err_temp_token_missing);
    }
    setLoading(true);
    try {
      const res = await Api.main.verify2FA({
        code: totpCode,
        tempToken: tempToken,
      });

      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem('token', res.token);
      sessionStorage.removeItem('tempToken');
      localStorage.removeItem('remember');
      setUser(res.user);
      history.push('/');
    } catch (e) {
      setErrorMsg(e.message || translation.err_two_fa_invalid_expired);
      setTotpCode('');
    } finally {
      setLoading(false);
    }
  }, [totpCode, tempToken, rememberMe, history, setUser, setErrorMsg]);


  const handleCancel = () => {
    sessionStorage.removeItem('tempToken');
    localStorage.removeItem('remember');
    history.push('/');
  }


  if (!tempToken) {
    return null;
  }

  return (
    <>
      <div className="app-wrapper min-vh-100 bg-white">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-inner-content-layout--main">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content">
                  <Grid container spacing={0} className="min-vh-100">
                    <Grid
                      item
                      lg={7}
                      xl={6}
                      className="d-flex align-items-center"
                    >
                      <Grid item md={10} lg={8} xl={7} className="mx-auto text_field_center ">
                        <Box
                          component="form"
                          onSubmit={handle2FAVerify}
                          className="py-4 w-70"
                        >
                          <div className="text-center">
                            <h1 className="display-4 mb-1 font-weight-bold">
                              {translation.enter_verification_code}
                            </h1>
                          </div>
                          <div className="text-center text-black-50 mb-4">
                            {translation.check_auth_app}
                          </div>
                          <div>
                            <div className="mb-3">
                              <TextField
                                fullWidth
                                variant="outlined"
                                label={translation.code_two_fa_label}
                                value={totpCode}
                                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                inputProps={{ maxLength: 6 }}
                                placeholder="123456"
                                required
                              />
                            </div>
                            <div className="text-center pt-4">
                              <Button
                                type="submit"
                                className="btn-second font-weight-bold w-50 my-2 pointer"
                                disabled={loading || totpCode.length !== 6}
                              >
                                {loading ? translation.verifying : translation.verify}
                              </Button>
                            </div>
                            <div className="text-center pb-4">
                              <Button
                                onClick={handleCancel}
                                className="btn-neutral-secondary font-weight-bold w-50 my-2 pointer"
                              >
                                {translation.cancel}
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid item lg={5} xl={6} className="d-flex">
                      <div className="hero-wrapper w-100  min-vh-lg-100">
                        <div className="flex-grow-1 w-100 d-flex align-items-center">
                          <div
                            style={{
                              top: 0,
                              left: 0,
                              position: "absolute",
                              height: "100%",
                              width: "100%",
                              backgroundColor: "#003333",
                            }}
                          />
                          <div className="bg-composed-wrapper--bg" />
                          <div className="bg-composed-wrapper--b" />
                          <div className="bg-composed-wrapper--content text-center p-5">
                            <div className="text-white px-0 px-lg-2 px-xl-4 login_title">
                              {translation.bar_control}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
